<template>
<span>{{content}}</span>
</template>

<script>

export default {
	name: "JmSimple",

	props: {
		content: [ String, Number ]
	}
};
</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/components/widgets/ItemViewWidgets/Simple.vue